<div [ngClass]="{'open': (isNavBarCollapsed$ | async) !== true}" id="header-navbar-wrapper">
    <ds-header></ds-header>
    <ds-navbar></ds-navbar>
</div>
